

















import { Component, Vue } from 'vue-property-decorator';
import { isiOS } from '@/utils/common';
import { getUrlParam } from '@/utils/common';

@Component({
  name: 'DownloadApp'
})

export default class DownloadApp extends Vue {
  downloadAppUrl = '';

  created() {
    document.title = '俏租机';

    const channel = getUrlParam('channel') || 'common';

    if (isiOS()) {
      this.downloadAppUrl = 'https://itunes.apple.com/cn/app/id1543645253';
    } else {
      this.downloadAppUrl = `https://qiaozuji-flms-public.oss-cn-shenzhen.aliyuncs.com/app/android/apk/${ channel }/com.qiaozuji.android.apk`;
    }
  }

  goToDownload() {
    window.location.href = this.downloadAppUrl;
  }
}
